<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui iconfont back" @click="$router.push({name:'my'})"></i>
      <h2>我的任务</h2>
    </div>




    <!--<ul>-->
      <!--&lt;!&ndash; <div v-if="!data.length" class="tips">暂无任务</div> &ndash;&gt;-->
      <!--<nodata v-if="!data.length"></nodata>-->
      <!--<li v-for="item in data">-->
        <!--<div class="title">-->
          <!--<p>{{item.name}}·{{item.pname}}</p>-->
          <!--<span>-->
            <!--{{item.create_date}}-->
            <!--<br>-->
            <!--{{item.title}}-->
          <!--</span>-->
        <!--</div>-->

      <!--</li>-->
    <!--</ul>-->
    <div class="table-body">
      <nodata v-if="!data.length"></nodata>
      <div class="table-body-item" v-for="(item, index) in data">

        <div class="item-title" @click="openTable(index)">
          <div class="title">
                 <span class="title-name">
                 <!--<div :class="{'open': index == isOpen}"></div>-->
              <!--项目名称 如-->
                  <div>{{item.name}}</div>
                </span>
          </div>
        </div>
        <!--点击项目名称展示项目详情-->
        <div class="item-content"
             v-if="isOpen == index">
          <ul class="list-container ">
            <li class="list-item" v-for="(task,i) in item.tasks">
              <div class="itemtip">
                <span>{{i+1}}</span>
                <span style="flex:2">{{task.title}}</span>
              </div>
              <div class="totalstip">
                <span>{{task.score}}<span v-if="task.score">%</span></span>
                <span>{{task.complete}}<span v-if="task.complete">%</span></span>
                <span class="owner">{{task.owner}}</span>
              </div>
              <div class="titletip">
                <span>完成度</span>
                <span>工作占比</span>
                <span>指派给</span>
              </div>

            </li>
          </ul>
        </div>


      </div>


    </div>
  </div>




  </div>
</template>

<script>
import nodata from './public/nodata'
export default {
  components:{
    nodata,
  },
  data () {
    return {
      data:[],
      isOpen:null, //表格展开
    }
  },
  methods:{
    openTable (index) {
      if ( this.isOpen == null ) {
        this.isOpen = index
      } else if (this.isOpen == index) {
        this.isOpen = null
      } else {
        this.isOpen = index
      }
    },

  },
  created () {
    this.$http.getMyMisson().then( res => {
      // 我的任务列表
      this.data = res.data
     // console.log(res.data)
    })
  },

}
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #FFF;
  }
  .table-header{
    background-color: rgba(99,105,73,.2);
    padding: 6px 0;
    color: #000;
    font-size: 0;
  }
  .list-container {
    background-color: #FAFAFA;
  }
  .itemtip{
    height:32px;
  }
  .list-item {
    /*项目详情列表*/
    color: #666666;
    border-left:0;
    height:2.66rem;
    padding:3px 0 0 2px;
  }
  .table-body{
    margin-top: 20px;
    height: calc(100% - 70px);
    overflow: scroll;
  }
  .item-title{
    width: 100%;
    padding: 2px 0px;
    border-bottom: 2px solid RGBA(151, 151, 151, .2);
    border-top: 2px solid RGBA(151, 151, 151, .2);
    cursor: pointer;
  }
  .item-title .title {
    display: flex;
    position: relative;
  }
  .item-title .title span {
    display: inline-block;
    align-items: center;
    color: #000;
    width: calc(100%/7);
    text-align: center;
  }
  .title{
    color: #333;
    position: relative;
    font-size:0.8rem;
    background: #fff;
    height: 0.9rem;
    line-height:0.9rem;
    border-left: 0.09375rem solid #5483D2;

  }
  .totalstip{
    /*padding-left:0.52rem;*/
     display: flex;
     /*工作占比等数字的显示*/
   }
  .totalstip>span{
    display: inline-block;
    height: 28px;
    color:#5482D2;
    font-size: 15px;
    flex:1;
   text-align: center;
    /*工作占比等数字的显示*/
  }
  .totalstip .owner{
    font-size:13px;

  }
  .titletip{
    display: flex;
  }
  .titletip>span{
    display: inline-block;
    flex:1;
    text-align: center;
    /*工作占比等数字的显示*/
  }

  .item-title .title span.title-name {

   width:100%;
    text-align: left;
    margin:0
  }
  .title-name div {
    flex: 1;
    font-size: 0.45rem;
  }



  /* 我的任务字段的css*/
  .header{
    width: 100%;
    color: #000;
    text-align: center;
    font-size: 0.375rem;
    background-color: #FFF;
    height: 1.1875rem;
    line-height: 1.1875rem;
    position: relative;
  }
  .header h2{
    color: #333;
    font-size: 0.4375rem;
  }
  .container ul{
    width: 100%;
    background: #fafafa;
  }

  .title span{
    color: #5482D2;
    display: block;
    font-size: 0.34375rem;
    padding-left: 3%;
    margin-top: 0.375rem;
  }


  .back{
    /*transform: rotate(90deg);*/
    display: inline-block;
    position: absolute;
    left: 0.34375rem;
    top:18%;
    font-size: 0.5rem;
    font-weight: bold;
    line-height: 0.78125rem;
    color: #86898E;
  }
  .tips {
    padding-top: 18.21%;
    font-size: 0.375rem;
    background-color: #fff;
    display: inline-block;
    width: 100%;
    text-align: center;
  }








</style>



// WEBPACK FOOTER //
// src/components/Mission.vue